import '../CreateEditDialog.scss';

import { Button } from 'primereact/button';
import { useMemo } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormDataHub } from '../../../../../../../types/api/hubs';
import { getDays } from '../CreateEditDialog.functions';
import OpeningHoursEditor from './OpeningHoursEditor';

function WorkingHours() {
  const { t } = useTranslation();
  const days = useMemo(() => getDays(t), [t]);

  const { fields, append, remove } = useFieldArray<FormDataHub, 'workingHours'>(
    {
      name: 'workingHours',
    }
  );

  const addDay = (dayOfWeek: number) => {
    if (!fields.some((f) => f.dayOfWeek === dayOfWeek)) {
      append({
        dayOfWeek,
        openingHours: [
          {
            from: '00:00',
            to: '00:00',
          },
        ],
      });
    }
  };

  const availableDays = useMemo(
    () => days.filter((d) => !fields.some((f) => f.dayOfWeek === d.dayOfWeek)),
    [days, fields]
  );

  return (
    <div className="intervals">
      {fields?.map((iv, idx) => (
        <div key={iv.dayOfWeek} className="time-row-working-hours">
          <OpeningHoursEditor dayIndex={idx} />
          {(idx === 5 || idx === 6) && (
            <Button
              type="button"
              label="×"
              className="remove-interval-btn p-button-danger"
              onClick={() => remove(idx)}
            />
          )}
        </div>
      ))}

      <div className="add-days">
        {availableDays.length > 0 && (
          <div className="add-days">
            <div className="day-buttons">
              {availableDays.map((d) => (
                <Button
                  key={d.dayOfWeek}
                  type="button"
                  label={d.label}
                  onClick={() => addDay(d.dayOfWeek)}
                  className="p-button-sm p-button-text"
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default WorkingHours;
